import { render, staticRenderFns } from "./PayInfo.vue?vue&type=template&id=2b2ae46f&scoped=true&"
import script from "./PayInfo.vue?vue&type=script&lang=js&"
export * from "./PayInfo.vue?vue&type=script&lang=js&"
import style0 from "./PayInfo.vue?vue&type=style&index=0&id=2b2ae46f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2ae46f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b2ae46f')) {
      api.createRecord('2b2ae46f', component.options)
    } else {
      api.reload('2b2ae46f', component.options)
    }
    module.hot.accept("./PayInfo.vue?vue&type=template&id=2b2ae46f&scoped=true&", function () {
      api.rerender('2b2ae46f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/publishGoods/components/PayInfo.vue"
export default component.exports